<script setup lang="ts">
import { getConfig } from '../../config/constants';

const config = getConfig(useRuntimeConfig());
const cookie = useCsrfCookie(`${config.domains.api}/v2/sanctum/csrf-cookie`);
</script>

<template>
  <slot v-if="cookie.error.value" name="error">
    <UiErrorApi :error="cookie.error.value" />
  </slot>
  <slot v-else-if="cookie.status.value !== 'success'" name="loading">
    <SessionSkeleton />
  </slot>
  <slot v-else />
</template>
